<template>
    <v-btn
        icon
        variant="text"
        :color="color"
        :size="btnSize"
        :loading="loading"
        @click="onClick"
    >
        <v-icon>{{ iconSource }}</v-icon>
    </v-btn>
</template>

<script>

export default {
    name: "AppFabButton",
    props: {
        iconName: {
            required: true,
            type: String
        },
        color: {
            type: String
        },
        small: {
            type: Boolean
        },
        loading: {
            type: Boolean
        },
        xSmall: {
            type: Boolean
        }
        
    },
    emits: ['click'],
    methods: {
        onClick() {
            this.$emit('click')
        }
    },
    computed: {
        btnSize() {
            if (this.xSmall) return 'x-small';
            if (this.small) return 'small';
            return 'default';
        },
        iconSource() {
            switch (this.iconName) {
                case 'icon-edit':
                case 'edit':
                    return 'mdi-pencil'
                case 'icon-share':
                case 'share':
                    return 'mdi-share'
                case 'icon-delete':
                case 'delete':
                    return 'mdi-trash-can-outline'
                case 'icon-download':
                case 'download':
                    return 'mdi-download-outline'
                case 'icon-calendar':
                case 'calendar':
                    return 'mdi-calendar';
                case 'icon-copy':
                case 'copy':
                    return 'mdi-content-copy';
                case 'icon-close':
                case 'close':
                    return 'mdi-close';
                case 'icon-add':
                case 'add':
                    return 'mdi-plus';
                case 'icon-print':
                case 'print':
                    return 'mdi-printer'
                case 'icon-menu':
                case 'menu':
                    return 'mdi-dots-vertical'
                case 'icon-chevrondown':
                case 'chevrondown':
                    return 'mdi-chevron-down'
                case 'icon-chevronup':
                case 'chevronup':
                    return 'mdi-chevron-up'
                case 'icon-chart':
                case 'chart':
                    return 'mdi-chart-line'
                case 'icon-swap':
                    return 'mdi-swap-vertical'
            }
        }
    }
}
</script>

<style scoped>

</style>